import { useState } from 'react';
import { getToken } from '../utils/common';
import { postV1AiVendorInsights } from '../api-client/api.ai-feature/api';

export const useVendorAICompare = (companyId: string | number | undefined) => {
  const [compareData, setCompareData] = useState<any>(null);
  const [compareLoading, setCompareLoading] = useState(false);
  const [compareError, setCompareError] = useState(false);

  const handleCompare = async (vendorIds: number[]) => {
    const cid = companyId || "";
    setCompareLoading(true);
    setCompareError(false);
    try {
      const res: any = await postV1AiVendorInsights({
        companyId: cid,
        vendorIds,
        ...(getToken() as any),
      });
      setCompareData(res?.data?.data ?? res?.data ?? null);
    } catch (e) {
      setCompareError(true);
    } finally {
      setCompareLoading(false);
    }
  };

  return { compareData, compareLoading, compareError, handleCompare, setCompareData };
};
